import { useEffect, useState } from "react";
import { RiComputerFill, RiMoonClearFill, RiSunFill } from "react-icons/ri"
import { Globals } from "utils/styleconfig"

const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => {
    // Get the initial theme from local storage or default to 'light'
    return localStorage.getItem("theme") || "light";
  });

  useEffect(() => {
    // Apply the current theme to the `html` element
    const root = document.documentElement;

    if (theme === "dark") {
      root.setAttribute("dark-theme", "dark");
    } else {
      root.removeAttribute("dark-theme");
    }

    // Store the theme in local storage
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <>
      {theme === "light" ? (
        <button
          className="p-2 rounded-full bg-gray-200"
          onClick={() => toggleTheme("dark")}
        >
          <RiSunFill color={Globals.colorDarkBlue} size={15} />
        </button>
      ) : theme === "dark" ? (
        <button
          className="p-2 rounded-full bg-gray-200"
          onClick={() => toggleTheme("light")}
        >
          <RiMoonClearFill color={Globals.colorDarkBlue} size={15} />
        </button>
      ) : (
        <button
          className="p-2 rounded-full bg-gray-200"
          onClick={() => toggleTheme("auto")}
        >
          <RiComputerFill color={Globals.colorDarkBlue} size={15} />
        </button>
      )}
    </>
  );
};


export default ThemeToggle